import React from 'react';
import { Route, Switch, Router } from 'react-router-dom';

import LogService from '@services/logger';
import { paths, TPaths } from '@helpers/Constants';
import BrowserHistory from '@helpers/BrowserHistory';
import pageConfig from '@config/pageConfig';

import './index.less';

// import Auth from '@views/modules/auth/Auth';
import Location from '../views/modules/map/MapLocation';

class AppRouter extends React.Component {
  componentDidCatch(error: Error, info: any): void {
    LogService.log(error, info.componentStack);
  }
  render() {
    const routes: Partial<TPaths> = Object.assign({}, paths);
    return (
      <Router history={BrowserHistory}>
        <Switch>
          <Route
            exact
            path={PUBLIC_URL + '/'}
            component={() => (
              <Location />
            )}
          />
          {Object.keys(routes).map(key => (
            <Route
              key={paths[key]}
              path={PUBLIC_URL + paths[key]}
              component={() => {
                const Component = pageConfig[key].component;
                if (pageConfig[key].auth) {
                  return (
                    // <Auth>
                    //   <Component />
                    // </Auth>
                    <Component />
                  );
                }
                if(Component) {
                  return <Component />;
                }
                // TODO 加个统一跳转的错误页面
                return null;
              }}
            />
          ))}
        </Switch>
      </Router>
    );
  }
}
export default AppRouter;
